import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-20 md:py-28 px-6 bg-base relative overflow-hidden" data-id="element-147">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-hero pointer-events-none" data-id="element-148" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-149">
        <FadeIn data-id="element-150">
          <h2 className="font-display text-4xl md:text-6xl font-bold text-text-primary mb-16" data-id="element-151">
            The Story Must Be Told.
          </h2>
        </FadeIn>

        <div className="space-y-12" data-id="element-152">
          <FadeIn delay={0.2} data-id="element-153">
            <p className="font-body text-lg text-text-secondary mb-2" data-id="element-154">
              Some stories deserve more than 48 hours.
            </p>
            <p className="font-body text-lg text-text-primary font-medium mb-6" data-id="element-155">
              This one gets 170 pages.
            </p>
            <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-156">
              Read The Full Story &rarr;
            </Button>
            <p className="font-ui text-xs text-text-muted mt-3 tracking-wide" data-id="element-157">
              7-day money-back guarantee. Zero risk.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-158">
            <div className="w-px h-12 bg-border-accent mx-auto" data-id="element-159" />
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-160">
            <p className="font-body text-lg text-text-secondary mb-6" data-id="element-161">
              Be the person who knows the full story.
            </p>
            <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-162">
              Get The Memorial Edition &rarr;
            </Button>
            <p className="font-ui text-xs text-text-muted mt-3 tracking-wide" data-id="element-163">
              Instant digital access. Download in seconds.
            </p>
          </FadeIn>

          <FadeIn delay={0.8} data-id="element-164">
            <div className="w-px h-12 bg-border-accent mx-auto" data-id="element-165" />
          </FadeIn>

          <FadeIn delay={1.0} data-id="element-166">
            <p className="font-body text-lg text-text-secondary mb-6" data-id="element-167">
              This edition won't stay open forever.
            </p>
            <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-168">
              Claim Your Copy Before It Closes &rarr;
            </Button>
            <p className="font-body text-accent-soft mt-3 text-sm italic" data-id="element-169">
              Memorial edition. Limited availability.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}